/**
 * Created by admin on 2018/1/26.
 */
import React from 'react';
import CircleBtn from './CircleBtn';
import { Input } from 'antd';

export default class Dial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialNum: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = nextProps;
    if (!visible) {
      this.setState({ dialNum: '' });
    }
  }

  render() {
    const { onCall } = this.props;
    return (
      <div className={'dial-panel-container'}>
        <div className={'dial-container'}>
          <div className={'show-num'}>
            <Input
              placeholder="8888@1.1.1.1/1.1.1.1"
              value={this.state.dialNum}
              onChange={e=>this.setState({dialNum: e.target.value})}
            />
          </div>
          <div className={'operate'}>
            <div className={'dial'}>
              <CircleBtn
                icon="icon-phone-control"
                mode="small-green"
                callback={() => {
                  if ('' === this.state.dialNum) {
                    return;
                  }
                  onCall(this.state.dialNum);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dial.js